// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3Nqp4{color:#6f7ea3;padding:32px 40px;position:relative}", ""]);
// Exports
exports.locals = {
	"patientsGestationalReport": "_3Nqp4"
};
module.exports = exports;
